import { graphql } from 'react-relay';

export const requestHometaxBlockNotification = graphql`
  mutation requestHometaxBlockNotificationMutation($refundId: String, $businessType: String = "indis") {
    requestHometaxBlockNotification(refundId: $refundId, businessType: $businessType) {
      result
      errors {
        code
        message
      }
    }
  }
`;
